import Api from "../../../app/apiRequest";
import BaseResponse from "../../../app/BaseResponse";
import SaveSearchModel from "../models/SavedSearchModel";

export interface SaveSavedSearchParam {
    component: string,
    queryJson: string,
    name: string
}

export interface DeleteSavedSearchParam {
    id: number
}

const SavedSearchApi = {
    GetAll() {
        return Api.get<null, BaseResponse<SaveSearchModel[]>>("/api/savedSearch/GetAll", null);
    },
    Save(param: SaveSavedSearchParam) {
        return Api.post<SaveSavedSearchParam, BaseResponse<SaveSearchModel>>("/api/savedSearch/Save", param);
    },
    Delete(param: DeleteSavedSearchParam) {
        return Api.post<DeleteSavedSearchParam, BaseResponse<string>>("/api/savedSearch/Delete", param);
    },
};
export default SavedSearchApi;